<template>
  <div id="app">
    <top-nav></top-nav>
      <router-view></router-view>
    <Footer></Footer>

  </div>
</template>

<script>
import TopNav from './components/common/TopNav.vue'
import Footer from './components/common/Footer.vue'
import Home from './components/HomePage/Home.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

export default {
  name: 'app',
  components: {
    TopNav,
    Home,
    Footer,
  }
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #2c3e50;
  }

</style>
